import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import "./Login.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from './App';

const useAuth = () => {
    return React.useContext(AuthContext);
}

export const Login = props => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [loginInvalid, setLoginInvalid] = useState(false);
    let location = useLocation();
    let navigate = useNavigate();

    const { onLogin, onLoad } = useAuth();

    const handleLogin = async () => {
        setLoading(true);
        try {
            await onLogin(email, password, onFailure);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    }

    const onFailure =(message)=> {
        toast.error(message, {})
    }

    React.useEffect(() => {
        onLoad();
    }, []);

    return (
    <div className="login-container login-page">
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick={true}
            pauseOnHover={true}
            draggable={true}
            progress="undefined"
        />
        <div className="login-header login-caret">
            <div className="login-content">
                <a href="/login" className="logo"></a>
                <p className="description">Please log in to access your area!</p>
            </div>
        </div>   
        <div className="login-progressbar">
           <div></div>
        </div>
        <div className="login-form">
            <div className="login-content">
                <div className="form-login-error">
                    <h3>{loginInvalid && "Invalid login"}</h3>
                    <p></p>
                </div>
                <div>    
                    <div className="form-group">
                        <div className="input-group">
                            <div className="input-group-addon">
                                <i className="icon-user"></i>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="user_login" 
                                id="email" 
                                placeholder="Username" 
                                autoComplete="off"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="input-group">
                            <div className="input-group-addon">
                                <i className="icon-key"></i>
                            </div>
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    name="user_pwd" 
                                    id="password" 
                                    placeholder="Password" 
                                    autoComplete="off"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                 />
                        </div>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary btn-block btn-login" onClick={handleLogin}>
                            <i className="icon-login"></i>Log In
                        </button>
                    </div>
                </div>    
                <div className="login-bottom-links">
                    <a href="" className="link">Forgot your password?</a>
                    <br />
                </div>
            </div>
        </div>
    </div>

        )
    }

export default Login;